"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get3 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _http = _interopRequireDefault(require("./http"));
var _serializer = _interopRequireDefault(require("./serializer"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Serialize data, adds default config and transfer to code http module
 *
 */
var PostSerializedHttpAbstract = /*#__PURE__*/function (_HttpAbstract) {
  (0, _inherits2["default"])(PostSerializedHttpAbstract, _HttpAbstract);
  var _super = _createSuper(PostSerializedHttpAbstract);
  function PostSerializedHttpAbstract() {
    (0, _classCallCheck2["default"])(this, PostSerializedHttpAbstract);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(PostSerializedHttpAbstract, [{
    key: "post",
    value: function post() {
      for (var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++) {
        _ref[_key] = arguments[_key];
      }
      var url = _ref[0],
        data = _ref[1],
        opts = _ref[2];
      return (0, _get3["default"])((0, _getPrototypeOf2["default"])(PostSerializedHttpAbstract.prototype), "post", this).call(this, url, (0, _serializer["default"])(data), opts);
    }
  }]);
  return PostSerializedHttpAbstract;
}(_http["default"]);
/**
 * Prepend endpoint address to url, and support passing data to
 * querystring when method is GET.
 */
var EndpointAbstract = /*#__PURE__*/function (_PostSerializedHttpAb) {
  (0, _inherits2["default"])(EndpointAbstract, _PostSerializedHttpAb);
  var _super2 = _createSuper(EndpointAbstract);
  function EndpointAbstract(baseUrl) {
    var _this;
    (0, _classCallCheck2["default"])(this, EndpointAbstract);
    _this = _super2.call(this);
    _this.baseUrl = baseUrl;
    return _this;
  }
  (0, _createClass2["default"])(EndpointAbstract, [{
    key: "request",
    value: function request(method, url) {
      var _get2;
      url = url.includes('://') ? url : this.baseUrl + url;
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }
      return (_get2 = (0, _get3["default"])((0, _getPrototypeOf2["default"])(EndpointAbstract.prototype), "request", this)).call.apply(_get2, [this, method, url].concat(args));
    }
  }]);
  return EndpointAbstract;
}(PostSerializedHttpAbstract);
exports["default"] = EndpointAbstract;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBO0FBQ0E7QUFBeUM7QUFBQTtBQUV6Qzs7OztBQUFBLElBSWVBLDBCQUEyQjtFQUFBO0VBQUE7RUFBQTtJQUFBO0lBQUE7RUFBQTtFQUFBO0lBQUE7SUFBQSxPQUN4QyxnQkFBaUM7TUFBQTtRQUFBO01BQUE7TUFBQSxJQUF2QkMsR0FBRztRQUFFQyxJQUFJO1FBQUVDLElBQUk7TUFDdkIsOEhBQWtCRixHQUFHLEVBQUUsMEJBQWMsRUFBQ0MsSUFBSSxDQUFDLEVBQUVDLElBQUk7SUFDbkQ7RUFBQztFQUFBO0FBQUEsRUFIK0NDLGdCQUFZO0FBTTlEOzs7O0FBQUEsSUFJOEJDLGdCQUFpQjtFQUFBO0VBQUE7RUFJN0MsMEJBQWFDLE9BQU87SUFBQTtJQUFBO0lBQ2xCO0lBQ0EsTUFBS0EsT0FBTyxHQUFHQSxPQUFPO0lBQUE7RUFDeEI7RUFBQztJQUFBO0lBQUEsT0FFRCxpQkFBU0MsTUFBTSxFQUFFTixHQUFHLEVBQWdCO01BQUE7TUFDbENBLEdBQUcsR0FBR0EsR0FBRyxDQUFDTyxRQUFRLENBQUMsS0FBSyxDQUFDLEdBQUdQLEdBQUcsR0FBRyxJQUFJLENBQUNLLE9BQU8sR0FBR0wsR0FBRztNQUFBLG1DQUQ3QlEsSUFBVztRQUFYQSxJQUFXO01BQUE7TUFFbEMsK0lBQXFCRixNQUFNLEVBQUVOLEdBQUcsU0FBS1EsSUFBSTtJQUMzQztFQUFDO0VBQUE7QUFBQSxFQVpvRFQsMEJBQTBCO0FBQUEiLCJuYW1lcyI6WyJQb3N0U2VyaWFsaXplZEh0dHBBYnN0cmFjdCIsInVybCIsImRhdGEiLCJvcHRzIiwiSHR0cEFic3RyYWN0IiwiRW5kcG9pbnRBYnN0cmFjdCIsImJhc2VVcmwiLCJtZXRob2QiLCJpbmNsdWRlcyIsImFyZ3MiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Jlc3QvZW5kcG9pbnQudHMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=